<template>
    <section class="modal-mask superadmin-modal superadmin-modal-accept">
        <div class="modal-wrapper">
            <div class="modal-container" v-click-outside="closeOpenModal">
                <div :class="['modal-body', { 'needs-confirmation-check': askForCheckmarkConfirm }]">
                    <div class="confirm-text" v-html="confirmText"></div>

                    <div v-if="askForCheckmarkConfirm" class="ask-to-confirm">
                        <div @click="isChecked = !isChecked" :class="['checkmark', { 'selected': isChecked }]">
                            <i class="material-icons">check</i>
                        </div>
                        <span class="confirm-text">I understand</span>
                    </div>
                </div>

                <div v-if="isInformative" class="modal-footer">
                    <CustomButton buttonType="close" :callback="closeOpenModal"/>
                </div>
                <div v-else class="modal-footer">
                    <CustomButton buttonType="accept" :callback="accepted" :isDisabled="askForCheckmarkConfirm && !isChecked"/>

                    <CustomButton buttonType="decline" :callback="denied"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import CustomButton from "./CustomButton";

    export default {
        name: "SuperAdminAcceptModal",
        components: { CustomButton },
        props: ["confirmText", "askForCheckmarkConfirm", "isInformative"],
        data() {
            return {
                isChecked: false,
            }
        },
        methods: {
            accepted() {
                this.$store.dispatch('triggerModalCallback');
            },
            denied() {
                this.$store.dispatch('triggerModalCallbackCancel');
                this.closeOpenModal()
            }
        }
    }
</script>

<style lang="scss">
    .modal-mask.superadmin-modal.superadmin-modal-accept {
        .modal-container {
            width: 350px;
        }

        .modal-body.needs-confirmation-check {
            .confirm-text {
                margin-bottom: 16px;
            }
        }

        .confirm-text {
            margin-bottom: 32px;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
        }

        .ask-to-confirm {
            display: flex;
            justify-content: center;
        }

        .checkmark {
            $checkmark-size: 16px;
            width: $checkmark-size;
            height: $checkmark-size;
            margin: 2px 8px 0 0;

            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;

            border: 2px solid $green;
            border-radius: 3px;
            background: #fff;
            cursor: pointer;

            &.selected {
                background: $green;

                i {
                    display: block;
                }
            }

            i {
                display: none;
                font-size: 14px;
                color: #fff;
            }
        }

        .modal-footer .button-container {
            margin-right: 16px;

            i {
                display: none;
            }

            &:last-of-type {
                margin-right: 0;
            }

            .button {
                width: 70px;
                height: 40px;
            }
        }
    }
</style>